import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    name: null,
    nickname: null,
    avatar: null,
    phone: null,
    token: null,
    grade_id: null,
    grade_name: null,
    hid: null,
    auth: false,
    balance: 0,
    upgrade_members_grade_id: 0
  },
  mutations: {
    // 用户登录成功，存储 token 并设置 header 头
    logined(state, token) {
      state.auth = true
      state.token = token
      window.localStorage.setItem('token', token)
    },
    // 用户刷新 token 成功，使用新的 token 替换掉本地的token
    refreshToken(state, token) {
      state.token = token
      window.localStorage.setItem('token', token)
      axios.defaults.headers.common['Authorization'] = state.token
    },
    // 登录成功后拉取用户的信息存储到本地
    profile(state, data) {
      state.name = data.name
      state.nickname = data.nickname
      state.phone = data.phone
      state.avatar = data.avatar
      state.grade_id = data.members_grade_id
      state.grade_name = data.grade_name
      state.hid = data.hid
      state.balance = data.balance
      state.upgrade_members_grade_id = data.upgrade_members_grade_id
      window.localStorage.setItem('grade_id', data.members_grade_id)
      window.localStorage.setItem('upgrade_members_grade_id', data.upgrade_members_grade_id)
    },
    // 用户登出，清除本地数据
    logout(state){
      state.name = null
      state.nickname = null
      state.phone = null
      state.avatar = null
      state.grade_id = null
      state.grade_name = null
      state.hid = null
      state.auth = false
      state.token = null
      state.balance = 0
      // 清除本地 token
      localStorage.removeItem('token')
      // 清除 auth
      window.localStorage.removeItem('auth')
    }
  },
  actions: {
    // 登录成功后保存用户信息
    logined({dispatch,commit}, token) {
      return new Promise(function (resolve, reject) {
        commit('logined', token)
        axios.defaults.headers.common['Authorization'] = token
        dispatch('profile').then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    // 登录成功后使用 token 拉取用户的信息
    profile({commit}) {
      return new Promise(function (resolve, reject) {
        axios.get(process.env.API_URL + '/user', {}).then(respond => {
          let r = respond.data
          if (r.success == 1) {
            commit('profile', r.data)
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    // 用户登出，清除本地数据并重定向至登录页面
    logout({commit}) {
      return new Promise(function (resolve, reject) {
        //commit('logout')
        //window.location.href = '/login'
        /*
        if(state.token){
          axios.get(process.env.API_URL + 'authorizations/logout', {headers:{'Authorization': state.token}}).then(respond => {
            Vue.$router.push({name:'login'})
          })
        }
        */
      })
    },
    // 将刷新的 token 保存至本地
    refreshToken({commit},token) {
      return new Promise(function (resolve, reject) {
        axios.post(process.env.API_URL + '/authorizations/current', {headers:{'Authorization': token}}).then(respond => {
          let r = respond.data
          if(r.success === 1) {
            commit('refreshToken', r.data.access_token)
          }
        })
      })
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js